import "../../sass/components/Chip.scss";

export default function Chip({label, color = "secondary", onDelete, dataTestid}) {
    return (
        <span data-testid={dataTestid} className={`chip chip-${color}`} >
            {label}
            {onDelete ? <i className="far fa-times"
                           onClick={onDelete}/>
                : null}
        </span>
    )
}
